module.exports = __webpack_public_path__ + "img/step-3.858acb78.jpg";